import React from 'react';
import { ChevronDown, User } from 'lucide-react';

const ROLES = ['Staff', 'Ops Manager', 'Admin'];

const RoleSwitcher = ({ role, onChange }) => {
  return (
    <div className="flex items-center gap-2">
      <span className="text-xs font-medium hidden sm:block" style={{ color: '#6b7280' }}>Viewing as:</span>
      <div className="relative">
        <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-sm font-semibold cursor-pointer bg-white"
          style={{ borderColor: '#e8ddd0', color: '#1f2937' }}>
          <User size={14} style={{ color: '#f59e0b' }} />
          <select
            value={role}
            onChange={e => onChange(e?.target?.value)}
            className="appearance-none bg-transparent border-none outline-none cursor-pointer pr-5 text-sm font-semibold"
            style={{ color: '#1f2937' }}
          >
            {ROLES?.map(r => (
              <option key={r} value={r}>{r}</option>
            ))}
          </select>
          <ChevronDown size={13} className="pointer-events-none absolute right-2" style={{ color: '#9ca3af' }} />
        </div>
      </div>
    </div>
  );
};

export default RoleSwitcher;
